import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '../../../reducers'
import { logoutAction } from '../../../actions/admin/adminTerminals'
import './adminheader.less'
import cargo from '../../../assets/cargo.png'

const mapDispatchToProps = {
  logout: logoutAction,
}
const mapStateToProps = (state: AppState) => ({
  error: state.adminTerminals.error,
})

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = typeof mapDispatchToProps

const AdminHeader: React.FC<DispatchProps & StateProps> = ({ logout, error }: DispatchProps & StateProps) => {
  return (
    <div className="admin-header">
      <div className="header">
        <img className="logo" src={cargo} alt="cargo" />
        <div className="header-space" />
        <button className="logout-button" onClick={() => logout()}>
          Logout
        </button>
      </div>
      <div className="error">{error}</div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHeader)
